import React, {useEffect, useState} from 'react';
import DatePicker from "react-datepicker";
import {cloneDeep} from 'lodash';
import * as CandidateService from "@app/services/CandidateService";
import {toast} from "react-toastify";
import moment from "moment";
import InputMoreModal from "@pages/candidate/commonview/InputMoreModal";
import {LOCAL_STORAGE_USER_LOGIN_INFO} from "@app/constants/Common";
import Select from "react-select";
import {requestGetUserList} from "@app/services/UserService";

const CandidateProcessNotes = (props) => {
    const [processList, setProcessList] = useState([]);
    const [selectedRecord, setSelectedRecord] = useState({});
    const [isEditProcessNote, setIsEditProcessNote] = useState(false);
    const [showInputMoreModal, setShowInputMoreModal] = useState(false);
    const [userLoginInfo, setUserLoginInfo] = useState({});
    const [filterUsers, setFilterUsers] = useState('');
    const [userOptions, setUserOptions] = useState([]);
    const [isFetchingUsers, setFetchingUsers] = useState(false);
    const {candidateId} = props

    const fetchCandidateProcessNotes = (canId, userIds) => {
        if (!canId) {
            return;
        }
        CandidateService.getCandidateProcessNotes(canId, userIds).then((res) => {
            setProcessList(res.content)
        }).catch((error) => {
            toast.error(`Có lỗi xảy ra trong quá trình xử lý.`);
        })
    };

    const updateCandidateProcessNotes = (pNotes) => {
        // setProcessNotes(processNotes)
        // setIsLoading(true)
        CandidateService.updateCandidateProcessNotes({candidate_id: candidateId, process_notes: pNotes}).then((res) => {
            console.log(JSON.stringify(res))
            toast.success(`Cập nhật thông tin thành công.`);
            setIsEditProcessNote(false)
        }).catch((error) => {
            toast.error(`Có lỗi xảy ra trong quá trình xử lý.`);
        })
    };

    const fetchUsers = () => {
        setFetchingUsers(true)
        requestGetUserList({}).then(res => {
            const userList = res.content.users
            const userOptionList = userList.map(user => {
                return  {value: user.id, label : user.username, id: user.id}
            })
            userOptionList.splice(0, 0, {value: "", label : "Tất cả users", id: ""})
            setUserOptions([...userOptionList])
            setUserOptions(userOptionList);
        }).finally(() => {
            setFetchingUsers(false)
        });
    };

    useEffect(() => {
        if (!userLoginInfo.id && localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO)) {
            setUserLoginInfo(JSON.parse(localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO)))
        }
    }, [])

    useEffect(() => {
        if (userLoginInfo.is_superuser && !isFetchingUsers) {
            fetchUsers()
        }
    }, [userLoginInfo])

    useEffect(() => {
        fetchCandidateProcessNotes(candidateId)
    }, [candidateId])

    const onChangeFilterUser = (item) => {
        if (!item.value) {
            setFilterUsers('');
        } else {
            setFilterUsers(item);
        }
        fetchCandidateProcessNotes(candidateId, item.value)
    };

    const onChangeProcessInput = (index, fieldName, value) => {
        console.log('onChangeProcessInput');
        processList[index][fieldName] = value
        setProcessList([...processList])
    };

    const onAddProcess = (event) => {
        console.log('onAddProcess');
        if (processList.length > 0) {
            let latestRow = processList[processList.length-1]

            let rowIsBlank = true
            Object.keys(latestRow).forEach(key => {
                if (latestRow[key]) {
                    rowIsBlank = false
                }
            })

            if (rowIsBlank) {
                alert("Tồn tại record chưa được nhập thông tin.")
                return;
            }
        }

        processList.push({
            index: processList.length + 1,
            discussion_note: '',
            note_time: new Date(),
            created_user: userLoginInfo.id,
        });

        setProcessList([...processList]);
    };


    const onDelete = (index) => {
        let pNotes = cloneDeep(processList)
        if (pNotes.length === 1) {
            pNotes = [];
        } else {
            pNotes.splice(index, 1);
        }
        setProcessList(pNotes)
    };

    const onShowMore = (item, index) => {
        item.index = index
        setSelectedRecord({...item})
        setShowInputMoreModal(true)
    };

    const onSaveMore = (inputValue) => {
        setShowInputMoreModal(false)
        const pNotes = processList.map(item => {
            if (item.index === selectedRecord.index) {
                item.discussion_note = inputValue
            }
            return item
        })
        setProcessList([...pNotes])
    };

    return (
        <div className='container-fluid'>
            <div className='card card-default'>
                <div className='card-header'>
                    <h3 className='card-title text-bold'>Process List</h3>
                    <div className={'card-tools'}>
                        <div className={''}>
                            {isEditProcessNote &&
                            <>
                                <button type='button'
                                        className='btn btn-default mr-2'
                                        onClick={() => {
                                            setIsEditProcessNote(false);
                                        }}
                                        >
                                    Cancel
                                </button>
                                <button type='button'
                                        className='btn btn-info mr-2'
                                        onClick={() => {
                                            updateCandidateProcessNotes(processList);
                                        }}
                                        >
                                    Save
                                </button>

                                <button className='btn btn-primary'
                                        type={'button'}
                                        onClick={() => onAddProcess()}>
                                    <i className='fas fa-plus'/> Thêm
                                </button>
                            </>
                            }
                            {!isEditProcessNote &&
                            <div className={"row"}>
                                {userLoginInfo.is_superuser &&
                                <div className={"mr-3"}>
                                    <Select options={userOptions}
                                            value={filterUsers}
                                            placeholder={"Tất cả users"}
                                            autocomplete={"true"}
                                            onChange={values => {
                                                onChangeFilterUser(values);
                                            }}

                                    />
                                </div>
                                }
                                <button type='button'
                                        className='btn btn-default float-right'
                                        onClick={() => {
                                            setIsEditProcessNote(true);
                                        }}
                                        >
                                    Edit
                                </button>
                            </div>
                            }
                        </div>
                    </div>
                </div>
                <div className='card-body table-responsive p-0 w-100'>
                    <table
                        className='table table-hover table-bordered text-nowrap'
                        style={{
                            maxHeight: '80vh',
                            overflow: 'scroll',
                            minHeight: 300
                        }}
                    >
                        <thead>
                        <tr>
                            <th>STT</th>
                            <th>Note discussion</th>
                            <th>Note time</th>
                            <th>User NL</th>
                            <th>Hành động</th>
                        </tr>
                        </thead>
                        <tbody>
                        {processList.map((item, index) => (
                            <tr key={`career_summary_${index}`}>
                                <td>{index + 1}</td>
                                <td>
                                    <textarea className='form-control'
                                           value={item.discussion_note ? item.discussion_note : ''}
                                           name={'discussion_note'}
                                           disabled={!isEditProcessNote || userLoginInfo.id !== item.created_user}
                                           onChange={event => onChangeProcessInput(index, 'discussion_note', event.target.value)} />
                                    <span className={'input-group-append'}>
                                        <button type='button' className='btn btn-sm btn-sm btn-warning btn-flat btn-sm'
                                                onClick={() => onShowMore(item, index)}>
                                            More
                                        </button>
                                    </span>
                                </td>
                                <td>
                                    <DatePicker
                                        showTimeSelect
                                        disabled={!isEditProcessNote || userLoginInfo.id !== item.created_user}
                                        selected={item.note_time ? new Date(item.note_time) : ''}
                                        dateFormat={"dd/MM/yyyy HH:mm:ss"}
                                        onChange={(value) => onChangeProcessInput(index, 'note_time', value)} className='form-control'/>
                                </td>
                                <td>
                                    {item.created_user_name}
                                </td>
                                <td>
                                    <button className='btn btn-danger' type={'button'}
                                       disabled={!isEditProcessNote || userLoginInfo.id !== item.created_user}
                                       onClick={() => onDelete(index)}>
                                        Xóa
                                    </button>
                                </td>
                            </tr>
                        ))}
                        </tbody>
                    </table>
                </div>
            </div>

            <InputMoreModal isShow={showInputMoreModal}
                            onClose={() => setShowInputMoreModal(false)}
                            onSave={(input) => onSaveMore(input)}
                            fieldTitle={"Note discussion"}
                            inputValue={selectedRecord.discussion_note}/>

        </div>
    );
};

export default CandidateProcessNotes;
